import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';
import partnerOneLogo from 'assets/partner_1_logo.png';
import partnerTwoLogo from 'assets/partner_2_logo.png';
import partnerThreeLogo from 'assets/partner_3_logo.png';
import partnerFourLogo from 'assets/partner_4_logo.png';
import partnerFiveLogo from 'assets/partner_5_logo.png';
import partnerSixLogo from 'assets/partner_6_logo.png';
import partnerSevenLogo from 'assets/partner_7_logo.png';

const Partners = () => {
  const partners = [
    {
      logo: partnerFourLogo,
      link: 'https://www.rockefellerfoundation.org/',
      height: '56px',
    },
    {
      logo: partnerThreeLogo,
      link: 'https://foundationcenter.org/',
      height: '58px',
    },
    {
      logo: partnerFiveLogo,
      link: 'http://usaforafrica.org/',
      height: '70px',
    },
    {
      logo: partnerOneLogo,
      link: 'http://www.acibaobab.org/',
      height: '50px',
    },
    {
      logo: partnerTwoLogo,
      link: 'https://www.globalgiving.org/',
      height: '23px',
    },
    {
      logo: partnerSixLogo,
      link: 'https://www.philanthropycircuit.org/',
      height: '23px',
    },
    {
      logo: partnerSevenLogo,
      link: 'https://www.repaoc.org/',
      height: '115px',
    },
  ];

  return (
    <div id="partners" className="partners inner-content">
      <Text type="heading" modifiers="heavy text-center">
        <FormattedMessage id="Partners.Title" defaultMessage="Our Partners" />
      </Text>
      <div className="row no-margin align-items-center">
        {partners.map((partner, i) => (
          <div key={i} className="col partner-info">
            <a href={partner.link} target="_blank" rel="noopener noreferrer">
              <img
                style={{ height: partner.height }}
                src={partner.logo}
                className="partner-logo"
                alt=""
              />
            </a>
          </div>
        ))}
      </div>
      {/* <Button type="primary cta__landing-page" onClick={props.displaySignUp}>Sign Up</Button> */}
    </div>
  );
};

export default Partners;



// WEBPACK FOOTER //
// ./src/components/HomePage/Partners.js